import yup, { booleanValidator } from '~/utils/validators.yup';

export const miscellaneousDetailRule = {
    miscellaneousDetail: yup.object().shape({
        hasDamage: booleanValidator,
        hasBlock: booleanValidator,
        hasEvade: booleanValidator,
        isTransformable: booleanValidator,
        isBlockIgnored: booleanValidator,
        isInnate: booleanValidator,
    }),
};
